import { Button, Checkbox, Radio, DatePicker, Form, Input, Modal, Select, Table, TimePicker } from 'antd';

const FormItemWithoutLabel = ({ className, ...props }) => (
    <Form.Item {...props} label={null} className={`mb-0 ${className}`} />
);

export default FormItemWithoutLabel;
